/* unplugin-vue-components disabled */import { render } from "./ButtonDialog.vue?vue&type=template&id=b65a22cc&scoped=true"
import script from "./ButtonDialog.vue?vue&type=script&lang=js"
export * from "./ButtonDialog.vue?vue&type=script&lang=js"

import "./ButtonDialog.vue?vue&type=style&index=0&id=b65a22cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b65a22cc"]])

export default __exports__